import React from 'react';

import { MultiSelect } from '@metarouter-private/mr-mui';

import useEventDebuggerStatusSelectProps from './useEventDebuggerStatusSelectProps';

export default function EventDebuggerStatusSelect() {
  const props = useEventDebuggerStatusSelectProps();
  return <MultiSelect {...props} />;
}
